import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import FilterIcon from '@mui/icons-material/FilterAlt'
import { colors } from '@theme/variables'

import { ManageFiltersText, ManageFiltersWrapper, StyledFilterButtonButton } from './index.styles'
import { FilterShortlistsButtonProps } from './types'

export const FilterShortlistsButton = ({ filtersCount, isDisabled, onClick }: FilterShortlistsButtonProps) => {
  const { t } = useTranslation()
  const filtersApplied = !!filtersCount

  const filterButtonText = useMemo(() => {
    if (filtersApplied) {
      return t(translationKeys.CUSTOM_LIST_FILTER_APPLIED, { count: filtersCount })
    }
    return t(translationKeys.CUSTOM_LIST_FILTER_SHORTLIST_BTN)
  }, [filtersApplied, filtersCount, t])
  return (
    <ManageFiltersWrapper $filtersApplied={filtersApplied} onClick={onClick} id="shortlist-filter">
      <ManageFiltersText $filtersApplied={filtersApplied}>{filterButtonText}</ManageFiltersText>
      <StyledFilterButtonButton $filtersApplied={filtersApplied} $disabled={isDisabled} data-testid="filter-shortlist-button">
        <FilterIcon htmlColor={filtersApplied ? colors.primary : colors.white} fontSize="small" />
      </StyledFilterButtonButton>
    </ManageFiltersWrapper>
  )
}
